<template>
  <fieldset class="number-input">
    <button
      class="increment increment__decrease"
      @click="val = { v: val - step, handler: 'input' }"
    >
      <i :class="Icon.Minus" />
    </button>
    <TextInput
      class="text-field"
      :value="val"
      :label-text="labelText"
      :error="error"
      :has-error="hasError"
      type="number"
      inputmode="number"
      @blur="val = { v: $event, handler: 'blur' }"
      @input="val = { v: $event, handler: 'input' }"
    />
    <button
      class="increment increment__increase"
      @click="val = { v: val + step, handler: 'input' }"
    >
      <i :class="Icon.Plus" />
    </button>
  </fieldset>
</template>

<script>
import TextInput from '@/components/inputs/TextInput';
import { Icon } from '@/lib/enum/Icon';

export default {
  name: 'NumberInput',
  components: {
    TextInput,
  },
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    field: {
      type: String,
      default: '',
    },
    labelText: {
      type: String,
      default: '',
    },
    step: {
      type: Number,
      default: 1,
    },
    hasError: {
      type: Boolean,
      default: false,
    },

    error: {
      type: [Array, String],
      default: null,
    },
  },
  data() {
    return {
      Icon,
    };
  },
  computed: {
    val: {
      get() {
        return Number(this.value);
      },
      set({ v, handler }) {
        this.$emit(handler, Number(v));
      },
    },
  },
};
</script>

<style lang="scss">
fieldset.number-input {
  display: inline-flex;
  border: 1px solid $gray-200;
  // This works with position fixed on text field details
  transform: scale(1);

  .increment {
    padding: 0 1rem;

    &__decrease {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-right: 1px solid $gray-200;
      background-color: $purple-50;
      color: $gray-400;
    }
    &__increase {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-left: 1px solid $gray-200;
      background-color: $purple-900;
      color: $white;
    }
  }

  .text-field {
    .v-input {
      border-radius: 0;
      border: none;

      &__slot {
        padding: 0 1rem !important;
        fieldset {
          border: none !important;
        }
        input {
          text-align: center;
        }
      }

      .v-text-field__details {
        position: fixed !important;
      }
    }
  }
}
</style>
